import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-openinghours',
    templateUrl: './openinghours.component.html',
    styleUrls: ['./openinghours.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OpeninghoursComponent {
}
